import { defineMessages } from "react-intl";

export const messages = defineMessages({
  inventoryLine: {
    id: "ari.management.sortAndFilter.inventoryLine",
    defaultMessage: "Ticker",
  },
});
